import React, { useMemo } from "react";
import Stockchart from "../components/Stockchart";
import { useDataWithRoute } from "../utils/hooks";
import { Spinner } from "reactstrap";
import {
  applyGrowthRateToNext,
  calculateWeightedGrowthRate,
  formatStockChartConfig
} from "../utils/Helpers";
import { VsiBubble } from "../styled/App.styled";
import { useVsiAppContext } from "../stores/VsiApp";

const chartConfig = {
  yAxis: {
    title: {
      text: "$ Dollars"
    }
  }
};

export default function CloudBudgetTrend() {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("CLOUD");

  const route = useMemo(() => `/api/v6/report/enterprise_cloud_trend_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const formattedChartData = useMemo(() => {
    const growthRate = calculateWeightedGrowthRate(
      recordset,
      ["total_cost", "budget"],
      6
    );

    const foreCastedData = applyGrowthRateToNext(
      recordset,
      ["total_cost", "budget"],
      growthRate,
      12
    );
    const newData = [...recordset, ...foreCastedData];

    const lineZoneValue = Date.parse(recordset?.[recordset.length - 1]?.collection_date?.split?.("T")?.[0]);

    let config = formatStockChartConfig(newData, [
      {
        name: "Spending",
        field: "total_cost",
        zoneAxis: "x",
        zones: [
          {
            value: lineZoneValue
          },
          {
            dashStyle: "Dash"
          }
        ]
      },
      {
        name: "Budget",
        field: "budget",
        zoneAxis: "x",
        zones: [
          {
            value: lineZoneValue
          },
          {
            dashStyle: "Dash"
          }
        ]
      }
    ]);

    return config.series || [];
  }, [recordset]);


  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubble>
      <Stockchart
        series={formattedChartData}
        height={400}
        navDisabled={true}
        disableLegend={true}
        config={chartConfig}
        formatData={"${point.y:,2f}"}
        formatLabels={"${value:,f}"}
        formatPoint={"{series.name}: <b>${point.y}</b>"}
      />
    </VsiBubble>
  );
}
